import React, { useContext } from 'react';
import { AppStateContext } from '../../AppState';
import { SkeletonTable } from '../../shared/components/Skeleton';
import { TablePagination } from '../../shared/components/table/TablePagination';
import { TicketListBoard } from '../../shared/components/table/TicketListBoard';
import { Ticket } from '../../shared/interfaces/ticket.interface';
import { ListContext } from './ListContextProvider';
import ListFunctions from './ListFunctions';
import useCustomViewsTickets from './useCustomViewsTickets';
import { ResultCount } from '../../shared/components/ResultCount';

interface Props {
  onTicketsSelected: (tickets: Ticket[]) => void;
  defaultFilters: FilterPropsItems[];
  listFeatureStates: ListFeatureStates;
}



export const List = ({ onTicketsSelected, defaultFilters, listFeatureStates }: Props) => {
  const state = useContext(AppStateContext);
  const { listStates } = useContext(ListContext);
  const { moveToPage, countPerPage } = ListFunctions();

  useCustomViewsTickets({ defaultFilters }); // Get tickets filtered by custom views

  return (
    <>
      {listStates.isTicketsFetching && <SkeletonTable />}
      {!listStates.isTicketsFetching && (
        <>
          <div style={{ height: 'calc(100vh - 139px - 2.25rem)', overflow: 'auto' }}>
            <TicketListBoard appStateValue={state} filterDropdownCount={state.filterDropdownCount} onTicketsSelected={onTicketsSelected} isFilterApplied={state.isFilterApplied} listFeatureStates={listFeatureStates} />
          </div>
          <div className='pr-4 h-9 flex items-center'>
            <ResultCount count={listStates.countTickets} />
            <TablePagination currentPage={listStates.currentPage} totalCount={listStates.countTickets} moveToPage={moveToPage} itemsPerPage={listStates.countPerPage} itemsPerPageChanged={countPerPage} />
          </div>
        </>
      )}
    </>
  );
};
